<template>
<transition name="el-zoom-in-center">
    <accident-report-submitted v-if="!this.active" :accident="accidentObj"/>
 
    <div class="content-wrapper" v-else-if="this.active">
       <loading v-show="isLoading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage"/>
            <!-- Content Header (Page header) -->
            <section class="content-header">
              <div class="titleDiv">
                
                    <h2><strong>Accident Report Form</strong></h2>
                    <hr>
                    <h4>This form will help us get <strong>pertinent</strong> information about your auto accident to best assist in making this process as easy and rewarding as possible for you.</h4>
<br>                    <p>Please fill out this form to the best of your knowledge. One of our Accident Support Specialists will recieve this report and assist you towards your accident claims goals! </p>
        
       
            </div>
            </section>
        <!-- Main content -->
        <section class="content">
                      
            <br>
             <!-- Default box -->
            <!--div class="box">
                    <div class="box-header">
                      <h4><strong>Name of Accident</strong></h4>
                    <hr>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                <div class="box-body">
                    <p>Please enter a name for your accident:</p>
                      <el-input clearable="true" v-model="accidentName" :placeholder="accidentName">
                      </el-input>
                    <hr>
                </div>
                <!-- /.box-body -->
       
            </div-->
            <!-- Default box -->
            <div class="box">
                    <div class="box-header">
                         <h4><strong>Type of Accident</strong></h4>
                    <hr>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                <div class="box-body">
                 
                    <p>Please select the type of accident you were in:</p>
                      <el-select v-model="accidentTypeSelect" placeholder="Select type of accident">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    <hr>
                </div>
                <!-- /.box-body -->
       
            </div>
             <!-- Default box -->
            <div class="box">
                <div class="box-header">
                     <h4><strong>Date and Time of Accident</strong></h4>
                                        <hr>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                <div class="box-body">
                   

                    <p>Please select the date and time of the accident.</p>
                   
                    <br>
                    <label for="example-datepicker" >Date of accident:<span style="content:'*';color:red;"> * </span> </label>
    <date-picker id="example-datepicker" v-model="dateValue" class="mb-2"></date-picker>
    <br>
    <br>
     <div>
                           <label for="example-timepicker">Time of accident: </label>

    <time-picker format="hh:mm A" v-model="timeValue" locale="en"></time-picker>
    <br>
  </div>
                    <!--el-radio-group v-model="accidentTimeRadio">
                        <el-radio-button label="Just now( less than 20 min.)"></el-radio-button>
                        <el-radio-button label="This Morning"></el-radio-button>
                        <el-radio-button label="Yesterday"></el-radio-button>
                        <el-radio-button label="One Week ago"></el-radio-button>
                        <el-radio-button label="Other"></el-radio-button>
                    </el-radio-group-->
                    <div style="margin: 15px 0;"></div>
            
                </div>
                <!-- /.box-body -->
            </div>
             <div class="box">
                <div class="box-header">
                     <h4><strong>Location of Accident</strong></h4>
<hr>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
            <div class="box-body">
                       
                        <h5>Please Enter Address of Accident</h5>
                        <el-input style="width:70%" placeholder="Please input Address" v-model="accidentLocation"></el-input>
                                                <!--h4>Or</-h4>
<div>
                        <h5>Select Address from here</h5>
<div class="user-location-btn">
                        <user-location/>
</div>
  
</div-->
                        <hr> </div>
        </div>
            <!-- Default box -->
            <!-- TODO: Fix this for mbile devices -->
            <div class="box">
                <div class="box-header">
                 <h4><strong>Vehicle Speed</strong></h4>
                    <hr>
                    <div class="box-tools pull-right">
                        <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="Collapse"> <i class="ti-minus"></i></button>
                    </div>
                </div>
                <div class="box-body">
                    
                    <span class="demonstration">Speed of vehicle<strong>(in MPH)</strong> at time of Impact?(Don't worry, it doesn't have to be exact)</span>
                    <div class="block"> 
                        <el-slider v-model="vehicleSpeedValue" show-input></el-slider>
                    </div>
                </div>
                <!-- /.box-body -->
            </div>
            <!-- Default box -->
            <div class="box">
                    <div class="box-header">
                      <h4><strong>Upload Media</strong></h4>
                          <hr>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                    <div class="box-body">
                          
                          <h5>Things that you feel are pertinent to the current accident(impact images, recorded conversations, license plate numbers, etc.)</h5>
                        <hr>
                         <!--keep "auto-upload" set to false to prevent CORS issues-->

                        <el-upload
                          class="upload-demo"  
                          action="https://jsonplaceholder.typicode.com/posts/"
                         list-type="picture"
                          :auto-upload="false"                            
                          :on-remove="handleRemove"
                          :before-upload="beforeUpload"
                          :limit="10"
                          :on-exceed="handleExceed"
                          :file-list="fileList"
                          :multiple="true"
                          :on-preview="handlePreview"
                          :on-success="handleSuccess"
                          :http-request="uploadFiles"
                          :on-error="handleError"
                          :on-change="handleChange"
                          >
                          <el-button size="small" type="primary">Click to upload</el-button>
                          <div slot="tip" class="el-upload__tip">Media files with a size less than 10Mb(limit of 10 files)</div>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" :title="fileNameSelected">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
                    </div>
            </div>
             <!-- Default box -->
            <div class="box">
                    <div class="box-header">
                      <h4><strong>Vehicle Make and Model</strong></h4>
<hr>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                
                <div class="box-body">
                                        
                    <p>Please select the Make and Model of your Vehicle:</p>
                    <br>
                    <h4>Make</h4>
                      <el-select v-model="makeValue" placeholder="Make" @change="updateModelDropdown()">
                        <el-option
                          v-for="item in this.makeOptions"
                          :key="item.brand"
                          :label="item.brand"
                          :value="item.brand">
                        </el-option>
                      </el-select>
                      <h4>Model</h4>
                        <el-select v-model="modelValue" placeholder="Model" :disabled="modelOptions.length===0">
                        <el-option
                          v-for="item in this.modelOptions"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <h4>Year</h4>
                        <el-select v-model="yearValue" placeholder="Year">
                        <el-option
                          v-for="item in yearOptions"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                   
                </div>
                <!-- /.box-body -->
       
            </div>
              <div class="box">
                      <div class="box-header">
        <h4><strong>Services Needed</strong></h4>
<hr>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                <div class="box-body" style="overflow: auto;">
           
                    <p>Please select the service(s) you would like to recieve for your accident:</p>
                    <br>
                      <el-checkbox-group v-model="servicesNeededCheckList" style="overflow: auto;">
                        <el-tooltip class="item" effect="dark" content="Have medical services assist you with your injuries." placement="top">
                        <el-checkbox  label="Medical"></el-checkbox>
                        </el-tooltip>
                        <el-checkbox label="Towing"></el-checkbox>
                        <el-tooltip class="item" effect="dark" content="Get legal assistance to help with your auto accident." placement="top">
                        <el-checkbox label="Legal"></el-checkbox>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Rent a vehicle to get around in the meanwhile." placement="top">
                        <el-checkbox label="Car Rental Service" ></el-checkbox>
                        </el-tooltip>
                                                <el-tooltip class="item" effect="dark" content="Look for a new vehicle." placement="top">

                        <el-checkbox label="Auto-Dealership" ></el-checkbox>
                                                </el-tooltip>
                      </el-checkbox-group>
                </div>
                <!-- /.box-body -->
      
            </div>
             <div class="box">
                <div class="box-header">
                 <h4><strong>Additional Information</strong></h4>
                <hr>
                    <div class="box-tools pull-right">
                        <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="Collapse"> <i class="ti-minus"></i></button>
                    </div>
                </div>
                <div class="box-body">
                
   <h5>Any Additional Information About the Accident you would like to note? This could be things like where you were when the other driver hit you, what the other car looked like, etc.</h5>
                      
                        <el-input type="textarea" :rows="4" placeholder="Input additional details Here..." v-model="additionalInfoTextArea"></el-input>
                        <hr>
                        <br>
            <div class="col-md-12 row-block"> <button  class="btn btn-primary btn-block" v-on:click="submitReport">Submit Accident Report</button> </div>

             </div>
        </div>
             
        </section>
        <!-- /.content -->
            <br>

    </div>
    </transition>
</template>
<script>
import UserLocation from '../components/modules/utilities/UserLocation.vue'
import AccidentReportSubmitted from './AccidentReportSubmitted.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TimePicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
const utilityFunctions = require('../common/utilityFunctions')
//import { util } from 'vue/types/umd';
const storageSvc = require('../services/Storage/storage')
const db = require('../services/database/database')
  const commonDB = require('../services/database/common')
import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
const to = require('await-to-js').default
const { v4: uuidv4 } = require('uuid');
const vehicleMakeModel = require('../store/vehicleMakeModelList.json')
const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
const Auth = require('../services/Authentication/auth')
const cliStoreOps = require('../common/clientStorageOperations')
const jwt_decode = require('jwt-decode');


  export default {
    name: 'FormSlider',
    components: { UserLocation, AccidentReportSubmitted, DatePicker, TimePicker, Loading },
async beforeMount(){
  this.userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
    this.userId = this.$cookie.get(cliStorNames. USER_ID.name)
if (!this.userToken || !this.userId){
         
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')
        }
  let userErr, userRes
          [userErr, userRes] = await to(Auth.getUser({ UID: this.userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')

          } 
          const decoded_header = jwt_decode(this.userToken)
          this.userAccountId = decoded_header.user_id
          console.log(this.userAccountId)
let userDbRes, userDbErr; 
                  [userDbErr, userDbRes]= await to(commonDB.getUserFromDB(this.userToken, this.userAccountId, this.userId))
                  if (userDbErr){
                      console.error(userDbErr)
                      this.$confirm("Unable to Load Profile Contents. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                  
                                    let pulledUserId = userDbRes.data.fields.userId.stringValue
                                    //VERY IMPORTANT! ==> Keeps 1 user from accesing another user's profile
                if (pulledUserId !== this.userId){
   
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
}
      let accidentNameSuffix = uuidv4().replaceAll("-", "")
      this.accidentName = "Accident_" + accidentNameSuffix
     
      var now = new Date()
       this.dateValue = now
var isPM = now.getHours() >= 12;
var isMidday = now.getHours() == 12;
var minutes = now.getMinutes()
var MerrideanTimeOffset = (now.getHours() - (isPM && !isMidday ? 12 : 0))
if (MerrideanTimeOffset < 10){
  MerrideanTimeOffset = '0' + MerrideanTimeOffset.toString()
}
if(minutes < 10){
  minutes = '0' + minutes
}
      this.timeValue = 
      [MerrideanTimeOffset, 
            minutes
           ].join(':') +
           (isPM ? ' PM' : 'AM');
           console.log("timeValue:", this.timeValue)
                      console.log("dateValue:", this.dateValue)

},
    data (){
      return {
        action: "http://localhost:8080/?#/accidentInformationPage",
          active: true,
          fileList: [],
        modelOptions: [],
        yearOptions: [1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022],
        makeOptions: vehicleMakeModel,
        vehicleSpeedValue: 0,
        dateValue: '', 
        files: '',
        userAccountId: "",
        dialogImageUrl: '',
        dialogVisible: false,
        inputFile: {},
        inputFilter: {},
        timeValue: '',
        isLoading: false,
                fullPage: true,
        accidentName: '',
        accidentId: '',
        servicesNeededCheckList: [],
        fileNameSelected: "",
        options:[{
          value: 'rearEnd',
          label: 'Rear-End'
        }, {
          value: 'headOn',
          label: 'Head-On'
        }, {
          label: 'Fender-Bender',
          value: 'fenderBender'
        }, {
          value: 'sideImpactCollision',
          label: 'Side-impact collision'
        }, {
          value: 'singleCar',
          label: 'Single Car Accident(No other driver involved)'
        }
           
        ],
        accidentTypeSelect: '',
        accidentTimeRadio: '',
        accidentLocation: '',
        additionalInfoTextArea: '',
        makeValue: '',
        timeSubmitted: "", 
        makeObj: {}, //obj to extract models and name 
        modelValue: '',
        yearValue: '',
        accidentObj: {},
        upload: {
          active: false
        }
      }
    },
    methods: {
      handleFileUploads(){
    this.files = this.$refs.files.files;
    console.log(this.files)
  },
  beforeUpload(file) {
    console.log("file size", file.size)
        const isLT10MB = file.size / 1024 / 1024 < 10;

      
        if (!isLT10MB) {
          this.$message.error('File size can not exceed 10MB.');
        }
        return  isLT10MB;
      },
       handleExceed(files, fileList) {
        this.$message.warning(`The number of files added is more than the limit of 10 files. Please remove one or more of your files if you would like to upload more files.`);
      },
      formatTooltip (val) {
        return val / 100
      }, 
      uploadFiles(file) {
          console.log(file)
      },
      handlePreview: function(file){
        console.log(file)
        console.log(this.fileList)
        this.dialogImageUrl = file.url;
        this.fileNameSelected = file.name
        this.dialogVisible = true;

      },
      handleChange: function(file, fileList){
        console.log(file)
        this.fileList = fileList; 
        console.log(this.fileList)
        let allClear = this.beforeUpload(file)
        if(!allClear){
                  this.fileList = this.fileList.filter( el => el.name !== file.name ); 

        }
        
               // console.log(fileList)

      },
      handleSuccess : function(file){
        console.log(file)
        this.fileList.push(file); 
        console.log("success")
               // console.log(fileList)

      },
      handleError: function(error){
        console.error("UNABLE TO LOAD FILE",  error)
      },
      handleRemove: function (file) {
        console.log(file)
        this.fileList = this.fileList.filter( el => el.name !== file.name ); 
        console.log(this.fileList)
      },
    handleUpload: function(file){
        console.log("uploading",  file)
      },
      updateModelDropdown(){
          this.modelValue = ''
          this.yearValue=  ''
          this.modelOptions =  this.makeOptions.filter(e => e.brand === this.makeValue)[0].models;//unsafe code
          console.log("changed", this.modelOptions)
      },
       onCancel() {
                console.log('User cancelled the loader.')
            },
      submitReport: async function(){
        if(!this.dateValue){
          this.$confirm("Accident Report must have an accident date.", 'Accident Date Missing', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'warning'})
        return;
                  
        }
        this.doAjax()
          this.accidentId = uuidv4()
          console.log("filelist", this.fileList)
          
        
       
let dbErr, dbRes;
      [dbErr, dbRes] = await to(this.addAccidentToDB()) //add accident to DB
      if (dbErr){
        
          console.error(dbErr)
          this.$confirm("Unable to add accident. " + dbErr.response.data.error.message ,  'ERROR', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'})
        return; //exit the function if DB entry cant be stored
      }
      //add files to storage
      let successfulFiles, unsuccessfulFiles;
      let storeErr, storeRes;
       [ storeErr, storeRes] = await to(this.addImagesToStorage(this.fileList, this.userId, this.accidentId))
       if (storeErr){
          console.error(storeErr)
       }
       console.log(storeRes)
       successfulFiles = storeRes.successfulFiles
       unsuccessfulFiles = storeRes.unsuccessfulFiles
      console.log("successfulFiles", successfulFiles)
      let successfulFileObjs = [];
      for (let fileObj of successfulFiles){
        successfulFileObjs.push({"filePath":
          fileObj.filePath,
          "dateUploaded":
          Date.now().toString(),
          "fileId":
          uuidv4().toString(),
          "contentType":
          fileObj.file.raw.type})
      }
      let formattedFiles = utilityFunctions.formatArrayOfObjectsGoogleFirestoreDB(successfulFileObjs)
      let updateErr, updateRes;
      [updateErr, updateRes] = await to(this.updateFilesUploadedDB( formattedFiles))
      if (updateErr){
        console.error(updateErr)
      }

       this.accidentObj = {
         accidentName: this.accidentName,
              accidentType: this.accidentTypeSelect,
              accidentTime: this.timeValue,
              accidentDate: this.dateValue,
              vehicleMake: this.makeValue,
              vehicleModel: this.modelValue,
              vehicleYear: this.yearValue,
              vehicleSpeed: this.vehicleSpeedValue.toString(),
              accidentId: this.accidentId,
              accidentLocation: this.accidentLocation,
              accidentClaimStatus: this.accidentClaimStatus,
              additionalInformation: this.additionalInfoTextArea,
              media: this.fileList,
              timeSubmitted: this.timeSubmitted,
              unsuccessfulFiles,
              successfulFiles,
              servicesNeeded: this.servicesNeededCheckList
          }
          this.isLoading = false
      this.active = false     
      },
   
      updateFilesUploadedDB: async function ( successfulFiles) {
 
        console.log("in updateFilesUploadedDB")
      let dbErr, dbRes;
      [dbErr, dbRes] = await to(commonDB.updateAccidentFiles(this.userToken, this.userAccountId,this.accidentId, successfulFiles));
      if (dbErr) {
        console.error("ERROR", dbErr);
        throw err;
      } else if (dbRes) {
        console.log("accident updated in DB!", dbRes);
      }
    },
    
      addImagesToStorage: async function(fileList, userId, accidentId){
        //adds all uploaded files to storage sequentially
                  console.log(fileList)

        let successfulFiles = [], unsuccessfulFiles = [];
        let metadata = {
          userId,
          accidentId}
      

        for (var file of fileList){
          console.log(file)
                const filePath = utilityFunctions.generateFirebaseStoragePath(userId, accidentId, file.name)

        var params = {
        metadata,
        file,  
        filePath,
        userToken: this.userToken
      }
        let storeErr, storeRes;
      [storeErr, storeRes] = await to(storageSvc.upload(params))
      if (storeErr){
        unsuccessfulFiles.push({file, filePath}) //will probably need to add something in the future to handle this(like a queue)
      console.error("storeErr", storeErr, unsuccessfulFiles)
      }
      else if (storeRes){
successfulFiles.push({file, filePath})
            
      }
      console.log("successFul push", successfulFiles)

        }
      let resObj = {
        successfulFiles,
         unsuccessfulFiles
      }
        return resObj
      },
       doAjax() {
        console.log("AJAX!")
                this.isLoading = true;
                // simulate AJAX
                setTimeout(() => {
                    this.isLoading = false
                }, 120000)
            },
            onCancel() {
                console.log('User cancelled the loader.')
            },
      addAccidentToDB: async function(){
         this.timeSubmitted = Date.now()
          
          
               let dbArrValues = [];
      for(var service of this.servicesNeededCheckList){
            dbArrValues.push({"stringValue": service})
        }
        let dbErr, dbRes;
      [dbErr, dbRes] = await to(commonDB.addAccidentToDb(this.userToken, this.userAccountId, this.accidentTypeSelect, this.accidentName, this.timeValue, this.dateValue, this.vehicleSpeedValue.toString(), this.accidentLocation, this.makeValue, this.modelValue, this.yearValue.toString(), this.additionalInfoTextArea, this.userId, this.timeSubmitted.toString(), this.accidentId.toString(), dbArrValues))
       if (dbErr){
        console.error(dbErr)
        throw err
    }
    else if(dbRes){
        console.log("Accident added to DB!", dbRes)
        return dbRes
    }
      }
    }
  }
</script>
<style scoped>

@media(min-width: 500px) {
.titleDiv {
  background:white;
  
}
}
@media(max-width: 500px){
  .titleDiv {
  background:white;
  margin-top: 10%;
  
}
}
</style>


// WEBPACK FOOTER //
// AccidentInformationInput.vue?182e418c